import { isly } from "isly";
import { GB as AddressGB } from "./GB";
import { Generic as AddressGeneric } from "./Generic";
import { SE as AddressSE } from "./SE";
export var Address;
(function (Address) {
    var _a;
    Address.Generic = AddressGeneric;
    Address.GB = AddressGB;
    Address.SE = AddressSE;
    _a = isly.union(Address.Generic.type, Address.GB.type, Address.SE.type).rename("isoly.Address").bind(), Address.type = _a.type, Address.is = _a.is, Address.flawed = _a.flawed;
})(Address || (Address = {}));
//# sourceMappingURL=index.js.map